import QuestionLabel from './QuestionLabel';
import React from 'react';
import Linkify from '../../Linkify.jsx';
import SafeHtml from '../../SafeHtml.jsx';

const AgreeToTermsQuestion = ({ value, label, setValue, settings, id }) => {
    let url = settings?.url || '';
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        // This also helps avoid javascript:// links
        url = `https://${url}`;
    }

    return (
        <div>
            <QuestionLabel label={label} settings={settings} />
            <div className="flex flex-wrap">
                <SafeHtml html={settings?.description} />
                {!!settings?.url && (
                    <a href={url} className="ml-2" target="_blank">
                        {settings?.urlLabel || 'View Terms'}
                    </a>
                )}
            </div>
            <label className="block mt-1">
                <input
                    className="mr-2"
                    type="checkbox"
                    name={id}
                    value="yes"
                    checked={value === 'yes'}
                    onChange={e =>
                        setValue(e.target.checked ? e.target.value : null)
                    }
                />
                {!!settings?.agreeLabel ? (
                    <Linkify>{settings?.agreeLabel}</Linkify>
                ) : (
                    'I agree'
                )}
            </label>
        </div>
    );
};

export default AgreeToTermsQuestion;
